import { setStore, getStore } from '@/util/store'
import { getRegionList } from "@/api/region";

const data = {
    state: {
        regionCode: getStore({name: 'regionCode'}) || '4403',
        regionList: getStore({name: 'regionList'}) || [],
    },
    mutations: {
        // 登录后获取区域编码，设置为缓存
        SET_AREA_CODE: (state, code) => {
            state.regionCode = code
            setStore({
                name: 'regionCode',
                content: state.regionCode
            })
        },
        SET_REGION_LIST: (state, list) => {
            state.regionList = [];
            state.regionList.push(list)
            setStore({
                name: 'regionList',
                content: state.regionList
            })
        },
    },
    actions: {
        // 查询权限范围的地市级联数据
        GetRegionList({commit}) {
            return new Promise((resolve, reject) => {
                getRegionList().then(res => {
                    if(res) {
                        commit('SET_REGION_LIST',res.data.data);
                    }
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            })
        },
    },
}
export default data


// WEBPACK FOOTER //
// ./src/store/modules/data.js